/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { Breakpoints } from "constants/Breakpoints";
import Colors from "constants/Colors";
import styled from "styled-components";

export const TooltipText = styled.div`
`;

export const TooltipBox = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: -40px;
  visibility: hidden;
  color: transparent;
  background-color: transparent;
  width: auto;
  min-width: 85px;
  padding: 5px 5px;
  border-radius: 4px;
  transition: visibility 0.5s, color 0.5s, background-color 0.5s, width 0.5s,
    padding 0.5s ease-in-out;
  &:before {
    content: "";
    width: 0;
    height: 0;
    left: 45px;
    top: -10px;
    position: absolute;
    border: 10px solid transparent;
    transform: rotate(135deg);
    transition: border 0.3s ease-in-out;
  }
  z-index: 99999;
  div {
    overflow: hidden;
 }

 
 @media screen and (min-width: ${Breakpoints.md}) {
  position: absolute;
  top: calc(100% + 10px);
  left: -55px;
  visibility: hidden;
  color: transparent;
  background-color: transparent;
  width: auto;
  min-width: 85px;
  padding: 5px 5px;
  border-radius: 4px;
  transition: visibility 0.5s, color 0.5s, background-color 0.5s, width 0.5s,
    padding 0.5s ease-in-out;
  &:before {
    content: "";
    width: 0;
    height: 0;
    left: 57px;
    top: -10px;
    position: absolute;
    border: 10px solid transparent;
    transform: rotate(135deg);
    transition: border 0.3s ease-in-out;
    z-index: 9999;
  }
  div {
    overflow: hidden;
 }
 &.filter {
  left: -10px !important;
    &:before {
      left: 10px;
    }
  }
}
`;

export const TooltipCard = styled.div`
  position: relative;
  padding: 0 5px 5px 0;
  & ${TooltipText}:hover + ${TooltipBox} {
    visibility: visible;
    color: ${Colors.WHITE};
    background-color: rgba(0, 0, 0);
    width: auto;
    padding: 8px 8px;
    &:before {
      border-color: transparent transparent rgba(0, 0, 0)
        rgba(0, 0, 0);
    }
    z-index: 9999999999;
  }
`;